<script>
import { addMinutes, getMinutes, setMinutes, differenceInSeconds, addSeconds } from 'date-fns'
import { mapState, mapGetters } from 'vuex'
import formatDate, { formatRequestData, formatGetTime } from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
import ReservationOrderForm from '@components/Orders/ReservationOrderForm'
import { genderFilter, bookingStatusFilter, orderStatusFilter, orderPaymentMethodFilter, paymentStatusMapFilter } from '@utils/filter-value-to-text'
import { saveState, getSavedState } from '@utils/browser-help'
import { authComputed } from '@state/helpers'
import productMixin from '@/src/mixins/product'
import helperMixin from '@/src/mixins/helperMixin'
import reservationOrderDetailParentMixin from '@/src/mixins/reservationOrderDetailParentMixin'
import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/zh-hk.js'
import VueScrollTo from 'vue-scrollto'
import overTimeMixin from '@/src/mixins/overTimeMixin'

import Vue from 'vue'
// v-contextmenu doc -> https://github.com/heynext/v-contextmenu/blob/2.x/docs/usage.md
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
import moment from 'moment'

const conditionList = (list) => {
  if (window.globalData.APP_TYPE === 'dingbeauty') {
    list = list.filter((item) => item.label !== '寵物備註')
  }
  return list.filter(({ condition }) => {
    if (condition) return condition()
    return true
  })
}
Vue.use(contentmenu)

export default {
  page: {
    title: '櫃檯管理',
    meta: [{ name: 'description', container: 'schedule' }],
  },
  filters: {
    genderFilter,
    formatDate,
    orderStatusFilter,
    bookingStatusFilter,
    orderPaymentMethodFilter,
    paymentStatusMapFilter,
  },
  components: {
    VueCal,
    CalendarItem: () => lazyLoadComponent(import('./CalendarItem.vue')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    ReservationOrderForm,
    ReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/ReservationOrderDetail')),
    StaffPriceAdjustment: () => lazyLoadComponent(import('@components/Orders/StaffPriceAdjustment')),
    RemarkDialog: () => lazyLoadComponent(import('./RemarkDialog.vue')),
    OffLineReserveWindow: () => lazyLoadComponent(import('@components/Orders/offLineReserveWindow')),
    PurchaseProducts: () => lazyLoadComponent(import('@components/Orders/PurchaseProducts')),
  },
  mixins: [productMixin, helperMixin, reservationOrderDetailParentMixin, overTimeMixin],
  props: {
    isSpace: {
      type: Boolean,
      default: false,
    },
    enableAdminSpaceOrder: {
      type: Boolean,
      default: false,
    },
    staffItems: {
      type: Array,
      required: true,
    },
    merchantProducts: {
      type: Array,
      required: true,
    },
    // 要找尋服務的type
    fetchType: {
      type: String,
      required: true,
    },
    fetchTypes: {
      type: Array,
      default: () => [],
    },
    selectProductId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tryingFetchSchedule: false,
      filterData: {
        productId: '',
        serviceId: '',
        orderStatus: '',
        scheduleItemId: '',
      },
      filterLocationList: [],
      filterServiceList: [],
      filterStatusList: [],
      filterStaffList: [],

      selectedDate: new Date(),
      productId: '',
      itemList: [],
      scheduleStaffs: this.staffItems,
      splitLabels: [],
      calendarEvents: [],
      events: [],
      originEvents: [],
      disabledDays: [],
      schedules: [],

      dialogVisible: false,
      dialogItem: {},
      dialogMode: 'edit', // edit 編輯, add 新增， view 預覽

      editable: {
        title: false,
        drag: false,
        resize: false,
        create: false,
        delete: false,
      },

      changingBooking: false,
      submitBooking: {},
      selectedContextEvent: {},

      // 營業時間
      openingHour: '00:00',
      closedHour: '23:59',

      tryingToGetOrder: false,
      drawerOrderData: {},
      drawerVisible: false,
      createOrderVisible: false,
      createOrderData: {},
      createOrderExtraData: {},
      componentKey: 0,
      scrollOptions: {
        container: '.vuecal__flex',
        easing: 'cubic-bezier(0.4, 0.0, 1, 1)',
        force: true,
        cancelable: true,
        x: false,
        y: true,
      },
      columnWidth: 300,
      autoColumnWidth: 0,
      calendarKey: 0,
      merchantNoteShow: false,
      columnShowList: [],
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      timeStep: 15, // 時間間隔預設參數
      remarkContextMenuStatus: false, // 查看備註的contextmenu
      openRemarkInfo: {}, // 此訂單的基本資訊（要拿去打開備註視窗使用）
      overTimeReserveWindowStatus: false, // 非營業時段預約確認視窗
      offTimeReserveResolve: () => {}, // 非營業時段預約確認視窗，await 參數function -> resolve
      offTimeReserveReject: () => {}, // 非營業時段預約確認視窗，await 參數function -> reject
      staffPriceAdjustmentWindowStatus: false, // 人員變價確認視窗
      staffPriceAdjResolve: () => {}, // 人員變價確認視窗，await 參數function -> resolve
      staffPriceAdjReject: () => {}, // 人員變價確認視窗，await 參數function -> reject
      offLineParams: {}, // 營業時間外的加減價
      serviceTimeSetting: {},
      storeInvoiceSetting: -1, // 看該店是否可以設定發票
      isCalendarOpen: false,
      isUseStaffPriceAdj: false, // 是否為美容師變價
      beforeApiExtraFields: [], // 點擊這家店的相關問答
      isAutoOpen: false, // goods的預設開啟參數
      forGoodsFakeData: {}, // 給商品的預設開窗資料
      purchaseDrawerOpen: false,
      scheduleIndexTimer: null,
      calMountPollTimer: null,
      currentOrderId: '', // 會員購買商品的訂單編號
    }
  },
  computed: {
    ...mapState('modifyOrder', ['memberInfo', 'modifyOrder']),
    ...mapGetters('modifyOrder', ['isModified']),
    remarkOptions() {
      return conditionList([
        {
          value: 'remark1',
          label: '會員等級',
          condition: () => {
            return this.$hasMemberLevel()
          },
        },
        {
          value: 'remark2',
          label: '客戶備註',
        },
        {
          value: 'remark3',
          label: '寵物備註', // 這邊不用換多語系，要用程式filter掉
        },
        {
          value: 'remark4',
          label: '服務備註',
        },
        {
          value: 'remark5',
          label: '使用人備註',
        },
        {
          value: 'remark6',
          label: '標籤',
        },
      ])
    },
    filterEventsData() {
      const result = this.changingBooking ? this.events : this.originEvents
      let partA = result.filter((item) => item.background || item.redirect) // 不知為啥要放背景的資料
      let partB = result.filter((item) => !item.background && !item.redirect) // 正式要篩選的資料(在vuecal內的資料)
      if (this.filterData.serviceId.length > 0) {
        partB = partB.filter((item) => item.customInfo.priceId === this.filterData.serviceId)
      }
      if (this.filterData.orderStatus.length > 0) {
        partB = partB.filter((item) => item.customInfo.orderStatus === +this.filterData.orderStatus)
      }
      if (this.filterData.scheduleItemId.length > 0) {
        partB = partB.filter((item) => item.customInfo.staffId === this.filterData.scheduleItemId)
      }
      return partA.concat(partB)
    },
    staffs() {
      return this.splitLabels.length
    },
    selectedDateString() {
      return this.selectedDate.format()
    },
    bookingTitle() {
      if (!this.selectedContextEvent.id) return ''
      const { productTitle, priceTitle, startDate } = this.selectedContextEvent
      const replaceDate = startDate.replace(/-/g, '/')
      return `${productTitle} ${priceTitle} ${formatDate(new Date(replaceDate), 'dateTime')}`
    },
    isReschedule() {
      return this.changingBooking && this.submitBooking.id
    },
    enableReschedule() {
      return this.selectedContextEvent.orderStatus && [1, 2, 3, 4].includes(this.selectedContextEvent.orderStatus) && !this.changingBooking
    },
    mirrorWidth() {
      return this.splitLabels.length * this.columnWidth
    },
    showRemarkPopover() {
      return this.columnShowList.length > 1 && this.columnShowList.some((column) => column.includes('備註'))
    },
    combineServiceEvents() {
      // 將events分為兩類：有customInfo的預約事件和沒有customInfo的排班事件
      const serviceEvents = this.events.filter((item) => item.customInfo)
      const NoneServiceEvents = this.events.filter((item) => !item.customInfo)
      // 根據orderContainerUuid進行合併預約事件
      const mergedEvents = serviceEvents
        .filter((item) => item.customInfo.orderContainerUuid)
        .reduce((acc, event) => {
          const { orderContainerUuid, pet } = event.customInfo
          const { split, start, end } = event
          // 檢查訂單編號(orderContainerUuid)/服務人員(split)/使用人(pet.id)相同的事件是否已經存在
          const existing = acc.find((item) => item.customInfo.orderContainerUuid === orderContainerUuid && item.split === split && item.customInfo.pet.id === pet.id)

          if (!existing) {
            acc.push({ ...event, customInfoList: [event.customInfo] })
          } else {
            if (start < existing.start) {
              existing.start = start
            }
            if (end > existing.end) {
              existing.end = end
            }
            console.log(event.customInfo)
            existing.customInfoList.push(event.customInfo)
          }

          return acc
        }, [])

      return [...mergedEvents, ...NoneServiceEvents]
    },
    ...authComputed,
  },
  watch: {
    selectedDateString() {
      // this.scrollToNow()
      this.scrollToCurrentTime()
    },
    timeStep() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToCurrentTime()
        }, 100)
      })
    },
    columnShowList(nvl) {
      saveState('columnShowList', nvl)
    },
    drawerVisible: {
      handler(nvl) {
        if (!nvl) this.$store.commit('modifyOrder/CLEAR_DATA')
      },
    },
  },
  async mounted() {
    await this.tryToFetchSchedule()
    this.calMountPollTimer = setInterval(() => {
      if (this.$refs.cal) {
        clearInterval(this.calMountPollTimer)
        this.calMountPollTimer = null
        this.handleSynchronizeScroll()
      }
    }, 300)
    this.$nextTick(() => {
      setTimeout(() => {
        // this.autoOpenDrawer() // 商品模組to-do：要開啟這個
        // this.scrollToNow()
        this.scrollToCurrentTime()
      }, 100)
    })
    const initUserOption = async () => {
      const columnWidth = (await getSavedState('columnWidth')) ?? 300
      const columnShowList = (await getSavedState('columnShowList')) ?? ['tag']
      await this.setColumnWidth(columnWidth)
      await this.setColumnShowList(columnShowList)
    }
    await initUserOption()
    this.handleWidth()
    window.addEventListener('resize', this.handleWidth)
  },
  beforeDestroy() {
    if (this.calMountPollTimer) {
      clearInterval(this.calMountPollTimer)
      this.calMountPollTimer = null
    }
    if (this.scheduleIndexTimer) {
      clearTimeout(this.scheduleIndexTimer)
      this.scheduleIndexTimer = null
    }
    this.handleSynchronizeScroll(false)
  },
  methods: {
    /**
     * @description 從服務/商品/儲值金/包月列表發上來的事件
     */
    async emitToLink(emitItem) {
      if (emitItem.key === 'service') {
        this.createOrderVisible = false
        await this.tryToFetchSchedule()
      }

      if (emitItem.key === 'deposit') {
        this.onClickDeposit()
        return
      }

      if (emitItem.key === 'prepaid') {
        this.onClickPrepaid()
      }
    },
    /**
     * @description 再次打開drawer
     */
    openAutoOpen() {
      this.autoOpenDrawer()
    },
    /**
     * @description 自動開窗
     */
    autoOpenDrawer() {
      // 如果沒購買商品模組，直接return
      if (!this.$hasGoods()) {
        return
      }
      if (Object.keys(this.forGoodsFakeData).length > 0) {
        this.closeBtnShowStatus = true
        const { id } = this.forGoodsFakeData
        const currentDate = new Date()
        this.onCellClick(
          {
            date: currentDate,
            split: id,
          },
          true
        )
      }
    },
    /**
     * @description 組成UNPAID顏色
     */
    composeUNPAIDStatus(customInfo) {
      // 如果包月不為null，代表內部一定有包月。就要去看||哪個是UNPAID
      if (customInfo.prepaidOrderPaymentStatus !== null) {
        return customInfo.paymentStatus === 'UNPAID' || customInfo.prepaidOrderPaymentStatus === 'UNPAID'
      } else {
        // 如果純預約，則直接看paymentStatus
        return customInfo.paymentStatus === 'UNPAID'
      }
    },
    /**
     * @description 檢查元素內容，讓他們zIndex 改變
     */
    setEventsIndex() {
      const cal = this.$refs.cal
      if (!cal || !cal.$el) return

      try {
        const elements = cal.$el.getElementsByClassName('vuecal__event')
        // 遍歷 HTMLCollection，檢查每個元素
        for (let i = 0; i < elements.length; i++) {
          let element = elements[i]

          // 遍历当前元素的 childNodes
          for (let j = 0; j < element.childNodes.length; j++) {
            let child = element.childNodes[j]
            // 檢查子元素是否有 'disable' class
            if (child.nodeType === Node.ELEMENT_NODE && child.classList.contains('disabled')) {
              elements[i].style.zIndex = '-1'
            }
            // 檢查子元素是否有 'disable' class
            if (child.nodeType === Node.ELEMENT_NODE && child.classList.contains('redirect')) {
            }

            if (child.nodeType === Node.ELEMENT_NODE && !child.classList.contains('redirect') && !child.classList.contains('disabled')) {
            }
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 關閉視窗並reload
     */
    async closeAndReload() {
      this.drawerVisible = false
      this.createOrderVisible = false
      await this.tryToFetchSchedule()
    },
    /**
     * @description 開啟or關閉月曆
     */
    calendarOpenControl() {
      this.isCalendarOpen = !this.isCalendarOpen
    },
    /**
     * @description 代客儲值
     */
    onClickDeposit() {
      try {
        this.$router.push({
          name: 'orders',
          params: {
            activeTabName: 'deposit',
            from: 'checkInList',
          },
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 代客購買包月
     */
    onClickPrepaid() {
      try {
        this.$router.push({
          name: 'prepaid',
          params: {},
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 當頁面小於481時 && 欄位寬度還是設定成手機時：要將其改回一般欄位寬度
     */
    handleWidth() {
      if (window.innerWidth > 481 && this.columnWidth === 150) {
        this.changeColumnWidth(300)
      }
    },
    /**
     * @description 從父組件更新商家id-> 重新撈資料
     */
    updateFilterFromFather(productId) {
      this.filterData.productId = productId
      this.fetchListAgain()
    },
    /**
     * @description 更動select時，重新撈一次資料
     */
    async fetchListAgain() {
      await this.tryToFetchSchedule()
    },
    bookingStatusFilter,
    /**
     * @description 開啟查看備註
     */
    async openRemarkDialog(event) {
      if (!this.showRemarkPopover) {
        this.$message.error('請勾選要顯示的欄位')
        return
      }
      this.remarkContextMenuStatus = true
      let orderInfo = await this.$store.dispatch('order/fetchSingle', event.orderId)
      this.openRemarkInfo = orderInfo
    },
    /**
     * @description 關閉查看備註
     */
    clickCloseRemarkFunc() {
      this.remarkContextMenuStatus = false
    },
    async reset() {
      this.$emit('reset')
      await this.tryToFetchSchedule()
    },
    /**
     * @description 重新撈取行事曆
     */
    async tryToFetchSchedule() {
      // v-contextmenu 會將 references 快取起來，導致後來的資料無法對應到
      this.originEvents = []
      this.events = []
      this.tryingFetchSchedule = true
      const result = await this.$store.dispatch('schedule/fetchList', {
        date: this.selectedDateString,
        ...this.filterData,
        types: [this.fetchType],
        scheduleItemTypes: this.fetchTypes,
        path: this.$route.path,
      })
      const { scheduleItems, orderStatus, products, staffs, services } = result
      this.filterLocationList = products // 服務地點
      this.filterServiceList = services
      this.filterStatusList = orderStatus
      this.filterStaffList = staffs
      this.filterSplitLabels(scheduleItems)
      this.filterEvents(scheduleItems)
      this.filterScheduleStaffs(scheduleItems)
      this.$emit('getProductList', {
        filterLocationList: this.filterLocationList,
      })
      const eventOnVueCalShow = this.events.filter((item) => item.customInfo)
      this.$nextTick(() => {
        setTimeout(() => {
          this.tryingFetchSchedule = false
          const eventCards = document.querySelectorAll('.vuecal__event:not(.vuecal__event--background)')

          if (eventOnVueCalShow.length > 0) {
            this.autoColumnWidth = eventCards.length * 200

            for (let i = 0, len = eventCards.length - 1; i < len; i++) {
              const width = parseInt(eventCards[i].style.width)
              eventCards[i].style.width = this.columnWidth === 0 ? '200px' : `${width - 5}%`
            }
          }
        }, 300)
        if (this.scheduleIndexTimer) {
          clearTimeout(this.scheduleIndexTimer)
        }
        this.scheduleIndexTimer = setTimeout(() => {
          this.scheduleIndexTimer = null
          this.setEventsIndex()
        }, 2000)
      })
    },
    getRandom(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    async tryToStoreItem(staff) {
      await this.$store.dispatch('schedule/storeItem', {
        date: this.selectedDateString,
        itemId: staff.id,
      })
      await this.tryToFetchSchedule()
    },

    filterScheduleStaffs(list) {
      this.scheduleStaffs = [...this.staffItems]
      const itemIds = list.map((item) => item.id)
      this.scheduleStaffs = [
        ...this.scheduleStaffs.filter((staff) => {
          return !itemIds.includes(staff.id)
        }),
      ]
    },
    filterSplitLabels(list) {
      // item.state 是filter掉人員為停權的
      const labels = list
        .filter((item) => item.scheduleDetails.some((detail) => detail.isFiltered === 0) && item.state === 1)
        .map((item) => {
          let storesTitle = []
          item.scheduleDetails.forEach((scheduleDetail) => {
            storesTitle.push(...scheduleDetail.storesTitle)
          })
          storesTitle = storesTitle.filter((title, index) => storesTitle.indexOf(title) === index).join('，')
          return {
            id: item.id,
            name: item.name,
            storesTitle: storesTitle,
            state: item.state,
          }
        })
      this.splitLabels = [...labels, { id: 'create-staff', type: 'create' }]
    },
    filterEvents(list) {
      const eventList = []
      const begin = `${this.selectedDateString} ${this.openingHour}`
      const finish = `${this.selectedDateString} ${this.closedHour}`
      list.forEach((item) => {
        // 訂單
        if (Object.keys(this.forGoodsFakeData).length === 0) {
          this.forGoodsFakeData = item
        }
        item.schedules.forEach((order) => {
          eventList.push({
            start: order.startDate,
            end: order.endDate,
            split: item.id,
            is_temp: order.is_temp,
            customInfo: { ...order, staffId: item.id },
          })
        })

        // 找出禁止時段
        if (item.scheduleDetails.length) {
          // 確保時間從早排到晚
          item.scheduleDetails.sort((prev, next) => formatGetTime(prev.startDate) - formatGetTime(next.startDate))

          item.scheduleDetails.forEach((detail) => {
            // 先把status狀態（是否開放預約）拿掉
            if (detail.isFiltered)
              eventList.push({
                start: detail.startDate,
                end: detail.endDate,
                split: item.id,
                disabled: true,
                background: true,
              })
          })

          item.scheduleDetails.reduce((prev, next) => {
            eventList.push({
              start: prev.endDate,
              end: next.startDate,
              split: item.id,
              disabled: true,
              background: true,
            })
            return next
          })

          eventList.push({
            start: begin,
            end: item.scheduleDetails[0].startDate,
            split: item.id,
            disabled: true,
            background: true,
          })
          eventList.push({
            start: item.scheduleDetails[item.scheduleDetails.length - 1].endDate,
            end: finish,
            split: item.id,
            disabled: true,
            background: true,
          })
        } else {
          eventList.push({
            start: begin,
            end: finish,
            split: item.id,
            disabled: true,
            background: true,
            is_temp: 0,
          })
        }
      })

      // 前往新增排班人員
      eventList.push({
        split: 'create-staff',
        start: begin,
        end: finish,
        redirect: true,
      })
      this.originEvents = [...eventList]
      this.events = [...eventList]

      // 選好想變更的時間後，換去其他日期又換回來
      if (this.isReschedule) {
        this.events.some((event, index) => {
          if (event.customInfo && event.customInfo.id === this.submitBooking.id) {
            this.events.splice(index, 1)
            return true
          }
          return false
        })
        this.events.push(this.submitBooking.eventData)
      }
    },
    /**
     * @description 預約時段，開啟drawer
     */
    async onCellClick({ date, split: itemId }, isAutoOpenStatus) {
      if (isAutoOpenStatus) {
        this.isAutoOpen = isAutoOpenStatus
      } else {
        this.forGoodsFakeData = {}
        this.isAutoOpen = false
      }
      if (!this.changingBooking) {
        const { startTime: startDate } = this.getStartEndTime(date, 'dateTime')
        const isExpired = formatGetTime(startDate) < new Date().getTime()
        this.handleCreateOrder(itemId, startDate, isExpired)
      } else {
        this.changeToOtherPeriod({ itemId, ...this.getStartEndTime(date) })
      }
    },
    /**
     * @description 人員變價按 是 or 否之後的btn
     */
    adjustStatus(status) {
      this.isUseStaffPriceAdj = status
      this.staffPriceAdjResolve()
    },
    /**
     * @description 關閉 是否指定美容師
     */
    closeSelfStaffPriceAdjustment() {
      this.staffPriceAdjReject()
    },
    /**
     * @description 開啟詢問變價視窗
     */
    async openStaffPriceAdj() {
      return new Promise((resolve) => {
        this.staffPriceAdjustmentWindowStatus = true
        this.staffPriceAdjResolve = () => {
          this.staffPriceAdjustmentWindowStatus = false // 無論是或否都會繼續往下
          resolve(true)
        }
        this.staffPriceAdjReject = () => {
          this.staffPriceAdjustmentWindowStatus = false
          resolve(false)
        }
      })
    },
    /**
     * @description 開啟非營業時段預約確認彈窗
     */
    async openOffTimeReserve() {
      return new Promise((resolve) => {
        this.overTimeReserveWindowStatus = true
        this.offTimeReserveResolve = () => {
          this.overTimeReserveWindowStatus = false
          this.updateStaffPrice()
          this.createOrderVisible = true
          resolve(true)
        }
        this.offTimeReserveReject = () => {
          this.overTimeReserveWindowStatus = false
          resolve(false)
        }
      })
    },
    /**
     * @description 非營業時間，按取消回上一步會跑這邊
     */
    previousFun() {
      this.offTimeReserveReject()
    },
    /**
     * @description 關閉非營業時段預約確認彈窗
     */
    offTimeReserveResolveFunc(params) {
      this.offLineParams = params
      this.offTimeReserveResolve()
    },
    /**
     * @description 移除加購
     */
    removeOffLineParams() {
      this.offLineParams = {}
    },
    /**
     * @description 更改x顯示與否
     */
    changeCloseBtnShowStatus(status) {
      this.closeBtnShowStatus = status
    },
    async changeToOtherPeriod(period) {
      let { id, orderId, startDate: oldStart, endDate: oldEnd } = this.selectedContextEvent
      oldStart = oldStart.replace(/-/g, '/')
      oldEnd = oldEnd.replace(/-/g, '/')
      const servicePeriodSecond = differenceInSeconds(new Date(oldEnd), new Date(oldStart))
      const newStart = `${formatDate(this.selectedDate)} ${period.startTime}`
      const newEnd = formatDate(addSeconds(new Date(newStart), servicePeriodSecond), 'dateTime')
      // 檢查能不能塞進去新的時段
      await this.$store.dispatch('order/fetchAvailablePeriod', {
        orderId,
        startDate: newStart,
        itemId: period.itemId,
      })

      // 將原本的時段移除
      this.events.forEach((event, index) => {
        if (event.customInfo && event.customInfo.id === id) {
          this.events.splice(index, 1)
        }
      })

      // 把資料塞進新的人員
      this.events.push({
        start: newStart,
        end: newEnd,
        split: period.itemId,
        customInfo: {
          ...this.selectedContextEvent,
          staffId: period.itemId,
        },
      })

      // 暫存資料
      this.submitBooking = {
        orderId,
        id: this.selectedContextEvent.id,
        staffId: period.itemId,
        startDate: newStart,
        eventData: {
          start: newStart,
          end: newEnd,
          split: period.itemId,
          customInfo: {
            ...this.selectedContextEvent,
            staffId: period.itemId,
          },
        },
      }
    },
    async fetchEvents() {
      if (!this.changingBooking) {
        const { productId: oriProductId } = this.filterData
        this.filterData = {
          productId: oriProductId,
          serviceId: '',
          orderStatus: '',
          scheduleItemId: '',
        }
      }

      await this.tryToFetchSchedule()
    },
    getStartEndTime(date, format = 'time') {
      const time = getMinutes(date)
      let startTime = ''
      if (this.timeStep === 10) {
        switch (true) {
          case time < 10:
            startTime = setMinutes(date, 0)
            break
          case time < 20 && time >= 10:
            startTime = setMinutes(date, 10)
            break
          case time < 30 && time >= 20:
            startTime = setMinutes(date, 20)
            break
          case time < 40 && time >= 30:
            startTime = setMinutes(date, 30)
            break
          case time < 50 && time >= 40:
            startTime = setMinutes(date, 40)
            break
          case time < 60 && time >= 50:
            startTime = setMinutes(date, 50)
            break
        }
      } else {
        switch (true) {
          case time < 15:
            startTime = setMinutes(date, 0)
            break
          case time < 30 && time >= 15:
            startTime = setMinutes(date, 15)
            break
          case time < 45 && time >= 30:
            startTime = setMinutes(date, 30)
            break
          case time < 60 && time >= 45:
            startTime = setMinutes(date, 45)
            break
        }
      }
      const endTime = addMinutes(startTime, this.timeStep)
      return { startTime: formatDate(startTime, format), endTime: formatDate(endTime, format) }
    },
    onContext(vm) {
      this.selectedContextEvent = { ...vm.data.attrs.event.customInfo }
    },
    onChangBooking() {
      this.changingBooking = true
    },
    async onCancelChanging() {
      this.changingBooking = false
      this.submitBooking = {}
      this.selectedContextEvent = {}
      this.updateFilter()
      await this.tryToFetchSchedule()
    },
    customCellClass(events) {
      if (events.length === 0) return ''

      const { expired, isOpen, canMoveSchedule, orderCount } = events[0].customInfo
      if (expired || !isOpen) return 'is-expired'
      return this.changingBooking ? (canMoveSchedule ? 'is-available' : 'is-full') : orderCount > 0 ? 'is-available' : ''
    },
    onClickDetail() {
      if (this.selectedContextEvent.orderId.length > 0) {
        this.tryToGetOrder(this.selectedContextEvent.orderId)
      }
    },
    async onClickChangingBooking() {
      this.changingBooking = true

      // 改變過濾的顯示狀態
      const { productId, priceId, orderStatus, staffId } = this.selectedContextEvent
      this.updateFilter({
        productId,
        serviceId: priceId,
      })
      if (orderStatus === 6) {
        this.filterData.scheduleItemId = staffId
      }
      await this.tryToFetchSchedule()

      // 改變日曆狀態
      this.tryToFetchCurrentMonthly()
    },
    onViewChange(viewInfo) {
      if (viewInfo.view !== 'month') return
      this.tryToFetchMonthly({
        startDate: formatRequestData(viewInfo.firstCellDate),
        endDate: formatRequestData(viewInfo.lastCellDate),
      })
    },
    async tryToFetchMonthly(date) {
      const list = await this.$store.dispatch('schedule/fetchMonthly', { ...date, scheduleId: this.changingBooking ? this.selectedContextEvent.id : undefined })

      this.calendarEvents = list.map((item) => ({
        start: item.date,
        end: item.date,
        customInfo: {
          ...item,
        },
      }))
      this.disabledDays = list.filter((item) => item.expired || !item.canMoveSchedule).map((item) => item.date)
    },
    getFilterId(filterName, title) {
      let id = ''
      this[`filter${filterName}List`].some((item) => {
        if (item.title === title) {
          id = item.id
          return true
        }
        return false
      })
      return id
    },
    updateFilter(
      data = {
        productId: '',
        serviceId: [],
        orderStatus: '',
        scheduleItemId: '',
      }
    ) {
      this.filterData = {
        ...this.filterData,
        ...data,
        serviceId: data.serviceId[0],
      }
    },
    async onClickModify() {
      const { orderId: id, staffId: itemId, startDate } = this.submitBooking
      await this.$store.dispatch('order/storeModifyOrder', {
        id,
        startDate,
        itemId,
      })
      this.$message({
        message: '已成功更換預約時間！',
        type: 'success',
      })

      this.onCancelChanging()
    },
    /**
     * @description 點擊事件本身
     */
    onEventClick(item) {
      const { split: itemId } = item
      this.overTimeReserveWindowStatus = false
      this.remarkContextMenuStatus = false
      if (this.changingBooking) return
      if (itemId === 'create-staff') this.goToSchedule()
    },
    async goToSchedule() {
      try {
        await this.$confirm('您即將離開前台接待前往排班功能進行排班，請問是否確定前往？', '您將離開此頁面', {
          confirmButtonText: '前往排班',
          cancelButtonText: '留在此頁',
          type: 'warning',
          center: true,
        })
      } catch (err) {
        if (err === 'cancel' || err === 'close') {
          return
        }
        throw err
      }
      this.$router.push({
        name: 'staff',
        params: {
          selectedDate: new Date(this.selectedDateString),
        },
      })
    },
    checkDisabledEvent(info) {
      return this.changingBooking ? this.selectedContextEvent.id !== info.id : info.isFiltered === 1
    },
    /**
     * @description 獲取此訂單內容-流程
     */
    async tryToGetOrder(orderId) {
      this.tryingToGetOrder = true
      await this.onlyFetchSingleOrder(orderId, () => {})
      this.tryingToGetOrder = false
      this.drawerVisible = true
    },
    /**
     * @description 點擊櫃檯管理行事曆「空白處」跳新增form出來的func
     */
    async handleCreateOrder(scheduleItemId, selectedTime, showExpiredAlert = false) {
      try {
        const { scheduleItems } = await this.$store.dispatch('schedule/fetchList', {
          date: this.selectedDateString,
          scheduleItemId,
          types: [this.fetchType],
          scheduleItemTypes: this.fetchTypes,
          path: this.$route.path,
        })
        const index = scheduleItems.findIndex((item) => item.id === scheduleItemId)
        const filterProduct = (scheduleDetails) => {
          let product = []
          this.storeInvoiceSetting = scheduleDetails[0]['products'][0]['storeInvoiceSetting'] ?? -1
          scheduleDetails.some((detail) => {
            const isBetweenStartAndEnd = formatGetTime(selectedTime) >= formatGetTime(detail.startDate) && formatGetTime(selectedTime) < formatGetTime(detail.endDate)
            if (isBetweenStartAndEnd) {
              product = detail.products
              return true
            }
            return false
          })
          return product
        }
        const clickTime = scheduleItems[index].scheduleDetails.find((item) => {
          const isBetweenStartAndEnd = formatGetTime(selectedTime) >= formatGetTime(item.startDate) && formatGetTime(selectedTime) < formatGetTime(item.endDate)
          return isBetweenStartAndEnd
        })
        this.schedules = scheduleItems[index].schedules
        this.createOrderData = this.filterProductInMixin(filterProduct(scheduleItems[index].scheduleDetails))
        this.createOrderExtraData = {
          id: scheduleItems[index].id,
          date: selectedTime,
          name: scheduleItems[index].name,
          state: scheduleItems[index].state,
          showExpiredAlert,
          storesTitle: clickTime?.storesTitle.join('，'),
        }
        if (this.createOrderData.length === 0) {
          this.$message.error('請重新選擇時段')
          return
        }
        await this.getProductExtraField()
        await this.validateOffTimeMoney()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 取得商家相關問答
     */
    async getProductExtraField() {
      try {
        if (this.createOrderData.length > 0) {
          const { orderExtrafields } = await this.$store.dispatch('product/fetchSingle', this.createOrderData[0].id)
          this.beforeApiExtraFields = orderExtrafields.byOrder || []
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 驗證是否超出營業時間[婚紗會解開]
     */
    async validateOffTimeMoney() {
      try {
        if (this.isSpace && !this.enableAdminSpaceOrder) {
          return
        }
        let { serviceTimeSetting } = await this.$store.dispatch('product/fetchSingle', this.createOrderData[0].id)
        this.serviceTimeSetting = serviceTimeSetting
        let selectDay = moment(this.createOrderExtraData.date).format('YYYY/MM/DD') // 取得現在是哪天
        let selectTime = moment(this.createOrderExtraData.date).format('HH:mm') // 取得現在是哪天
        let dayOfTheWeek = moment(this.createOrderExtraData.date).day() === 0 ? 7 : moment(this.createOrderExtraData.date).day() // 取得星期幾
        let isCrossOverOpenTime = this.isCrossOverTime(serviceTimeSetting, dayOfTheWeek - 1 === 0 ? 7 : dayOfTheWeek - 1, selectDay, selectTime)
        let isTodayOpenTime = this.isTodayTimeOk(serviceTimeSetting, dayOfTheWeek, selectDay, selectTime)
        if (isCrossOverOpenTime && isTodayOpenTime) {
          const confirmed = await this.openOffTimeReserve()
          if (!confirmed) return
        } else {
          this.updateStaffPrice()
          this.createOrderVisible = true
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 依照變價 -> 是 or 否，去修正shceduleDetails
     */
    updateStaffPrice() {
      // 如果「要變價」則要修改掉price，price變成scheduleItemPrice
      if (this.isUseStaffPriceAdj) {
        this.createOrderData.forEach((orderItem) => {
          orderItem.prices.forEach((itemDetail) => {
            this.$set(itemDetail, 'price', itemDetail.scheduleItemPrice)
          })
        })
      }
    },
    /**
     * @description 驗證是否要開啟人員變價詢問窗
     */
    async validateStaffPriceAdjustment() {
      if (this.isSpace && !this.enableAdminSpaceOrder) {
        return
      }
      await this.openStaffPriceAdj()
    },
    /**
     * @description 關閉此新增drawer後，重新fetch資料
     */
    async onCreateOrderDone() {
      await this.tryToFetchSchedule()
      this.$refs.orderForm.closeDrawer()
      this.createOrderVisible = false
    },
    /**
     * @description 關閉此編輯drawer後，重新fetch資料
     */
    async onEditOrderDone() {
      await this.tryToFetchSchedule()
      this.$refs.orderFormEdit.closeDrawer()
      this.drawerVisible = false
    },
    async CreateGoodsOrderDone(id) {
      this.currentOrderId = id
      this.$refs.purchaseDrawer.closeDrawer()
      this.purchaseDrawerOpen = false
    },
    tryToFetchCurrentMonthly() {
      const { firstCellDate, lastCellDate } = this.$refs['sm-cal'].getViewInfo()
      const startDate = formatRequestData(firstCellDate)
      const endDate = formatRequestData(lastCellDate)
      this.tryToFetchMonthly({ startDate, endDate })
    },
    onRenderedCalendarItem() {
      this.tryToFetchCurrentMonthly()
    },
    handleSynchronizeScroll(bind = true) {
      const cal = this.$refs.cal
      if (!cal || !cal.$el) return

      const $header = cal.$el.getElementsByClassName('vuecal__header')[0]
      const $body = cal.$el.querySelector('[row]')
      const $scrollbar = this.$el.querySelector('#custom-scrollbar')
      if (!$header || !$body || !$scrollbar) return

      let animationFrameId = null

      const handleHeaderScroll = () => {
        $body.scrollLeft = $header.scrollLeft
        $scrollbar.scrollLeft = $header.scrollLeft
      }
      const handleBodyScroll = () => {
        $header.scrollLeft = $body.scrollLeft
        $scrollbar.scrollLeft = $body.scrollLeft
      }

      const handleScrollbarScroll = () => {
        $header.scrollLeft = $scrollbar.scrollLeft
        $body.scrollLeft = $scrollbar.scrollLeft
      }

      if (bind) {
        const scrollHeaderHandler = () => {
          if (animationFrameId) return
          animationFrameId = requestAnimationFrame(() => {
            handleHeaderScroll()
            animationFrameId = null
          })
        }

        const scrollBodyHandler = () => {
          if (animationFrameId) return
          animationFrameId = requestAnimationFrame(() => {
            handleBodyScroll()
            animationFrameId = null
          })
        }

        const scrollbarScrollHandler = () => {
          if (animationFrameId) return
          animationFrameId = requestAnimationFrame(() => {
            handleScrollbarScroll()
            animationFrameId = null
          })
        }

        $header.addEventListener('scroll', scrollHeaderHandler)
        $body.addEventListener('scroll', scrollBodyHandler)
        $scrollbar.addEventListener('scroll', scrollbarScrollHandler)
      } else {
        $header.removeEventListener('scroll', handleHeaderScroll)
        $body.removeEventListener('scroll', handleBodyScroll)
        $scrollbar.removeEventListener('scroll', handleScrollbarScroll)
      }
    },
    handleSynchronizeScroll2(bind = true) {
      const $header = this.$refs.cal.$el.getElementsByClassName('vuecal__header')[0]
      const $body = this.$refs.cal.$el.querySelector('[row]')
      const $scrollbar = this.$el.querySelector('#custom-scrollbar')
      if (bind) {
        $header.addEventListener('scroll', () => {
          $body.scrollLeft = $header.scrollLeft
          $scrollbar.scrollLeft = $header.scrollLeft
        })
        $body.addEventListener('scroll', () => {
          $header.scrollLeft = $body.scrollLeft
          $scrollbar.scrollLeft = $body.scrollLeft
        })
        $scrollbar.addEventListener('scroll', () => {
          $header.scrollLeft = $scrollbar.scrollLeft
          $body.scrollLeft = $scrollbar.scrollLeft
        })
      } else {
        $header.removeEventListener('scroll', () => {
          $body.scrollLeft = $header.scrollLeft
          $scrollbar.scrollLeft = $header.scrollLeft
        })
        $body.removeEventListener('scroll', () => {
          $header.scrollLeft = $body.scrollLeft
          $scrollbar.scrollLeft = $body.scrollLeft
        })
        $scrollbar.removeEventListener('scroll', () => {
          $header.scrollLeft = $scrollbar.scrollLeft
          $body.scrollLeft = $scrollbar.scrollLeft
        })
      }
    },
    // 前人寫的方法，用途是讓vuecal時間滾動至頂部，似乎無效，使用scrollToCurrentTime代替
    // scrollToNow() {
    //   const now = new Date()
    //   const minutes = (now.getHours() - 6) * 60 + now.getMinutes()
    //   const pxFerMinute = 50 / 15
    //   if (now.format() === this.selectedDateString) {
    //     this.$refs.cal.$el.querySelector('.vuecal__bg').scrollTop = minutes * pxFerMinute - 50
    //   } else {
    //     this.$refs.cal.$el.querySelector('.vuecal__bg').scrollTop = 600
    //   }
    // },
    scrollToElement(el) {
      VueScrollTo.scrollTo(el, 500, this.scrollOptions)
    },
    scrollToDrawer() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.orderForm.$el.querySelector('.el-drawer').scrollTop = 900
        }, 200)
      })
    },
    checkAdd(info) {
      return info.childrenOrders.some((item) => {
        return item.status === 2
      })
    },
    addItems(order) {
      let list = []
      order.params.forEach((item) => {
        if (item.type === 'cosmetic-add') {
          list.push(item)
        }
      })
      order.childrenOrders.forEach((item) => {
        item.items.forEach((i) => {
          if (i.type === 'cosmetic-add') {
            list.push(i)
          }
        })
      })
      return list
    },
    async changeColumnWidth(value) {
      await this.setColumnWidth(value)
    },
    async setColumnWidth(value) {
      this.columnWidth = value
      await saveState('columnWidth', value)
    },
    async setColumnShowList(value) {
      this.columnShowList = value
      await saveState('columnShowList', value)
    },
    slotServiceHeight(slot) {
      const minutes = slot.customInfo.serviceTime + slot.customInfo.bufferTime
      const height = minutes * 3.33333333
      return height
    },
    hasPrepaidParams(params) {
      return params.some((item) => {
        return item.type === 'prepaid'
      })
    },
    /**
     * @description 使用者換掉timeStep
     */
    changeTimeStep(selectTime) {
      this.timeStep = selectTime
    },
    onClickPurchase() {
      this.purchaseDrawerOpen = true
    },
    scrollToCurrentTime() {
      const cal = this.$refs.cal
      if (!cal || !cal.$el) {
        console.error('無法取得vuecal行事曆')
        return
      }

      const calTimeEl = cal.$el.querySelectorAll('.vuecal__time-cell-label')
      if (calTimeEl.length) {
        const date = new Date()
        const hour = date.getHours()
        let minute = date.getMinutes()

        // 計算當前時間所在區間
        minute = Math.floor(minute / this.timeStep) * this.timeStep
        if (minute === 0) minute = '00'
        const currentTime = hour + ':' + minute
        const timeArr = Array.from(calTimeEl)
        const target = timeArr.find((time) => time.innerText === currentTime)

        target ? target.scrollIntoView({ behavior: 'smooth', block: 'start' }) : console.error('時間取得失敗')
      } else {
        console.error('無法取得vuecal行事曆')
      }
    },
    hideOrderInfo(event) {
      const isCrowded = this.columnWidth <= 300 && this.timeStep >= 60
      const isOrder = event?.customInfo?.orderId
      const heightNotEnough = isOrder ? event.customInfo.serviceTime / this.timeStep <= 3 : false

      return heightNotEnough || isCrowded
    },
  },
}
</script>

<template>
  <div>
    <!-- 上面行事曆寬度 -->
    <div :class="[$style.pageTitle, $style.upperIndex]">
      <div class="leftItem">
        <!-- 商品模組to-do：要開啟這個 -->
        <template v-if="false">
          <el-button class="is-round" @click="openAutoOpen">
            <BaseIcon name="arrow-left" />
            重新搜尋
          </el-button>
          <div class="upperInfo">
            <p>地點：中山店</p>
            <p>客戶：訪客A</p>
          </div>
          <el-button class="is-round" @click="openAutoOpen">
            目前總訂單
          </el-button>
          <div class="verticalLine"> </div>
        </template>
        <div class="upperItemDisplay">
          <div class="innerItem">
            <div class="innerItemText">行事曆寬度：</div>
            <div class="choiceDisplay">
              <div class="text-btn" :class="[{ isActive: columnWidth === 150 }, 'phoneSelectWidth']" @click="changeColumnWidth(150)">手機</div>
              <span style="padding:0 20px 0 10px;color:#dcdfe6" class="phoneSelectWidth"> | </span>
              <div class="text-btn" :class="{ isActive: columnWidth === 200 }" @click="changeColumnWidth(200)">變小</div>
              <span style="padding:0 20px 0 10px;color:#dcdfe6"> | </span>
              <div class="text-btn" :class="{ isActive: columnWidth === 300 }" @click="changeColumnWidth(300)">一般</div>
              <span style="padding:0 20px 0 10px;color:#dcdfe6"> | </span>
              <div class="text-btn" :class="{ isActive: columnWidth === 600 }" @click="changeColumnWidth(600)">加大</div>
            </div>
          </div>
          <div class="innerItem">
            <div class="innerItemText">時間間隔：</div>
            <div class="choiceDisplay">
              <div class="text-btn" :class="{ isActive: timeStep === 60 }" @click="changeTimeStep(60)">60 分鐘</div>
              <span style="padding:0 15px 0 10px;color:#dcdfe6"> | </span>
              <div class="text-btn" :class="{ isActive: timeStep === 30 }" @click="changeTimeStep(30)">30 分鐘</div>
              <span style="padding:0 15px 0 10px;color:#dcdfe6"> | </span>
              <div class="text-btn" :class="{ isActive: timeStep === 15 }" @click="changeTimeStep(15)">15 分鐘</div>
              <span style="padding:0 15px 0 10px;color:#dcdfe6"> | </span>
              <div class="text-btn" :class="{ isActive: timeStep === 10 }" @click="changeTimeStep(10)">10 分鐘</div>
            </div>
          </div>
        </div>
        <div class="upperBtnDisplay">
          <el-button style="text-align: center;" type="primary" class="is-round" @click="onClickDeposit">
            <BaseIcon name="plus" />
            代客儲值
          </el-button>

          <el-button style="text-align: center;" type="primary" class="is-round" @click="onClickPrepaid">
            <BaseIcon name="plus" />
            代客購買包月
          </el-button>

          <el-button v-if="hasGoods" style="text-align: center;" type="primary" class="is-round" @click="onClickPurchase">
            <BaseIcon name="store" />
            購買商品
          </el-button>
        </div>
      </div>
      <div :class="$style.fieldStyle">
        <div class="showText">
          <BaseIcon name="calendar-edit" />
          欄位顯示
        </div>
        <el-select v-model="columnShowList" popper-class="isStylecColumnShowList" placeholder="欄位顯示" multiple>
          <el-option label="欄位顯示" value disabled></el-option>
          <el-checkbox-group v-model="columnShowList">
            <el-option v-for="item in remarkOptions" :key="item.value" :label="item.label" :value="item.value">
              <el-checkbox :label="item.label"></el-checkbox>
            </el-option>
          </el-checkbox-group>
        </el-select>
      </div>
    </div>
    <!-- 中間search part -->
    <BaseTableSearch
      v-slot="{ fields }"
      class="isForTab2"
      hide-action
      :class="[$style.upperIndex]"
      :default-value.sync="filterData"
      :border="true"
      :hide-reset="changingBooking"
      @reset="reset"
      @tryToFetchList="tryToFetchSchedule"
    >
      <el-form-item prop="serviceId">
        <el-select v-model="fields.serviceId" :disabled="changingBooking" @change="fetchListAgain">
          <el-option label="所有服務項目" value></el-option>
          <el-option v-for="(service, value) in filterServiceList" :key="value" :label="service.title" :value="service.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="!changingBooking" prop="orderStatus">
        <el-select v-model="fields.orderStatus" @change="fetchListAgain">
          <el-option label="所有預約狀態" value></el-option>
          <el-option v-for="(status, value) in filterStatusList" :key="value" :label="status.title" :value="status.orderStatus.toString()"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="scheduleItemId">
        <el-select v-model="fields.scheduleItemId" @change="fetchListAgain">
          <el-option :label="changingBooking ? '可執行的所有人員' : '所有人員'" value></el-option>
          <el-option v-for="(staff, value) in filterStaffList" :key="value" :label="staff.name" :value="staff.id"> </el-option>
        </el-select>
      </el-form-item>
    </BaseTableSearch>
    <!-- 下半部card -->
    <el-card v-loading.fullscreen.lock="tryingToGetOrder" element-loading-text="取得訂單資訊中" shadow="never" style="margin-bottom:0" :class="[$style['card-wrapper']]">
      <div class="vue-cal-layout" :style="changingBooking ? 'padding-bottom: 85px;' : ''">
        <div class="schedule-calendar-collapse">
          <el-button v-if="!isCalendarOpen" class="closeCalendar" @click="calendarOpenControl">關閉月曆</el-button>
          <el-button v-if="isCalendarOpen" class="openCalendar" @click="calendarOpenControl"> {{ '>' }} </el-button>
          <div class="vue-cal-left" :class="{ openStatus: isCalendarOpen }">
            <CalendarItem
              v-slot="{ data: { cell, events } }"
              ref="sm-cal"
              :selected-date.sync="selectedDate"
              :calendar-events="calendarEvents"
              :disable-days="changingBooking ? disabledDays : []"
              @view-change="onViewChange"
              @rendered="onRenderedCalendarItem"
            >
              <span class="vuecal__cell-date" :class="customCellClass(events)">{{ cell.content }}</span>
            </CalendarItem>
            <div class="only-bottom-line" style="margin-top:12px;margin-bottom:24px"></div>
            <p :class="$style.status">行事曆狀態</p>
            <div :class="$style['calendar-status-wrapper']">
              <div :class="$style['calendar-status']">
                <div class="mark mark-1">1</div>
                <div>當天</div>
              </div>
              <template v-if="changingBooking">
                <div :class="$style['calendar-status']">
                  <div class="mark mark-available">1</div>
                  <div>有排班＋尚可預約</div>
                </div>
                <div :class="$style['calendar-status']">
                  <div class="mark mark-full">1</div>
                  <div>有排班＋無時段可預約</div>
                </div>
                <div :class="$style['calendar-status']">
                  <div class="mark mark-3">1</div>
                  <div>已過期 / 店休</div>
                </div>
              </template>
              <template v-else>
                <div :class="$style['calendar-status']">
                  <div class="mark mark-available">1</div>
                  <div>有預約</div>
                </div>
                <div :class="$style['calendar-status']">
                  <div class="mark mark-2">1</div>
                  <div>有營業</div>
                </div>
                <div :class="$style['calendar-status']" style="width:50%">
                  <div class="mark mark-3">1</div>
                  <div>已過去 / 無營業</div>
                </div>
              </template>
            </div>

            <p :class="$style.status" style="margin-top: 20px;margin-bottom:5px">預約狀態</p>
            <div :class="$style['calendar-status-wrapper']">
              <div :class="$style['order-status']">
                <div class="mark mark-1"></div>
                <div>已完成</div>
              </div>
              <div :class="$style['order-status']">
                <div class="mark mark-2"></div>
                <div>已報到</div>
              </div>
              <div :class="$style['order-status']">
                <div class="mark mark-3"></div>
                <div>待報到</div>
              </div>
              <div :class="$style['order-status']">
                <div class="mark mark-4"></div>
                <div>未報到</div>
              </div>
              <div :class="$style['order-status']">
                <div class="mark mark-5"></div>
                <div>未付款</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div> -->
        <div class="schedule-wrap">
          <VueCal
            ref="cal"
            class="full-cal vuecal--full-height-delete"
            :class="[
              $style.schedule,
              $style[`split-labels-${staffs}`],
              { [$style['is-changing']]: changingBooking },
              { isWidth600: columnWidth === 600 },
              { isWidth300: columnWidth === 300 },
              { isWidthPhone: columnWidth === 150 },
              { isWidth200: columnWidth === 200 },
              { [$style.isPhone]: columnWidth === 150 },
              { [$style.isAuto]: columnWidth === 0 },
              { [$style.isChanging]: changingBooking },
              { [$style.isFull]: changingBooking && !isCalendarOpen },
              { [$style.isFull2]: changingBooking && isCalendarOpen },
              { [$style.isFull3]: !changingBooking && isCalendarOpen },
              { [$style.isFull4]: !changingBooking && !isCalendarOpen },
              { [$style.min15Height]: timeStep === 15 },
              { [$style.min10Height]: timeStep === 10 },
              { [$style.min30Height]: timeStep === 30 },
              { [$style.min60Height]: timeStep === 60 },
            ]"
            active-view="day"
            locale="zh-hk"
            :selected-date="selectedDate"
            :time-from="0 * 60"
            :time-to="24 * 60"
            :split-days="splitLabels"
            :sticky-split-labels="true"
            :editable-events="editable"
            :events="changingBooking ? events : combineServiceEvents"
            :time-step="timeStep"
            :disable-views="['years', 'year', 'week', 'day', 'month']"
            :hide-title-bar="true"
            :time-cell-height="50"
            :snap-to-time="1"
            :on-event-click="onEventClick"
            @cell-click="onCellClick"
            @view-change="fetchEvents"
          >
            <template v-slot:split-label="{ split }">
              <div v-if="split.type === 'create'" :class="$style['split-label']" style="text-align: center">
                <BaseIcon name="plus" style="font-size: 15px"></BaseIcon>
              </div>
              <div v-else :class="$style['split-label']"
                >{{ split.name }} <span v-if="split.state === 0">(停權中)</span>
                |
                <span :class="[{ isWidth600: columnWidth === 600 }, { isWidth300: columnWidth === 300 }, { isWidthPhone: columnWidth === 150 }, { isWidth200: columnWidth === 200 }]">{{
                  split.storesTitle
                }}</span>
              </div>
            </template>
            <template v-slot:event="{ event }">
              <div v-if="event.customInfo && event.is_temp === 1" v-contextmenu:contextmenu :event="event" :class="$style.eventMask">
                <p>暫定預約</p>
              </div>
              <div
                v-if="event.customInfo"
                v-contextmenu:contextmenu
                class="wrap event-card"
                :class="[
                  bookingStatusFilter(event.customInfo.orderStatus, 'color'),
                  { 'is-disabled': checkDisabledEvent(event.customInfo) },
                  { isHelper: event.customInfo.isHelper === 1 && event.customInfo.isBeautician === 0 },
                  { isUNPAID: composeUNPAIDStatus(event.customInfo) },
                  { isUNPAIDADD: checkAdd(event.customInfo) },
                ]"
                style="height: inherit; padding-left: 10px; padding-right: 10px"
                :style="{ 'padding-top': hideOrderInfo(event) ? '0' : '10px', 'padding-bottom': hideOrderInfo(event) ? '0' : '10px' }"
                :event="event"
                :data-event-id="event.customInfo.orderContainerUuid"
              >
                <div :class="$style.mainBlock" :style="{ 'padding-top': hideOrderInfo(event) ? 0 : '20px' }">
                  <template v-if="!hideOrderInfo(event)">
                    <div v-if="event.customInfo.source" class="specify-schedule-item">
                      {{ event.customInfo.source === 'manual' ? '線下' : '線上' }}
                      <span v-if="event.customInfo.is_specify_schedule_item">
                        - 指定
                      </span>
                    </div>
                    <div v-if="hasPrepaidParams(event.customInfo.params)" class="info-icon isPrepaid">
                      方案抵扣
                    </div>
                    <div v-else class="info-icon">
                      單次預約
                    </div>
                  </template>
                  <div class="contextPart">
                    <!-- 名字 -->
                    <div class="name" :style="{ 'padding-top': hideOrderInfo(event) ? '0' : '15px' }">
                      <div> {{ event.customInfo.pet.name }} - {{ event.customInfo.customerName }} {{ event.customInfo.customerGender | genderFilter }} </div>
                      <div v-if="event.customInfo.merchantNote && columnShowList.includes('note')" class="text-muted-0" style="padding-top:5px">
                        {{ event.customInfo.merchantNote }}
                      </div>

                      <div v-if="columnShowList.includes('會員等級') && $hasMemberLevel() && event.customInfo.level" class="levelTitle">
                        {{ event.customInfo.level.title }}
                      </div>
                      <div v-if="!!event.customInfo.tags && event.customInfo.tags.length > 0 && columnShowList.includes('標籤')" class="tagsGroup">
                        <div class="text-muted-0" style="margin-bottom:10px">標籤</div>
                        <div class="tagsBody">
                          <span v-for="(item, index) in event.customInfo.tags" :key="index" class="tagsTitle">
                            {{ item }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- 時間 -->
                    <div class="title" :event="event">
                      <div class="time" style="padding-right:10px">{{ event.start.format('HH:mm') + ' ~ ' + event.end.format('HH:mm') }}</div>
                      <span v-if="event.customInfo.bufferTime > 0" class="text-muted-0">(緩衝時間 {{ event.customInfo.bufferTime }} 分鐘)</span>
                    </div>
                    <!-- 服務項目 -->
                    <div class="text-muted-0" style="margin-bottom:10px">服務項目</div>
                    <template v-for="item in event.customInfoList">
                      <div :key="item.orderId">
                        <div style="margin-bottom:6px">
                          <p v-for="(title, index) in item.priceTitle" :key="index" class="mb-1 mt-1">{{ title }}</p>
                        </div>
                      </div>
                    </template>
                    <!-- 加購項目 看似不會顯示了 -->
                    <template v-if="addItems(event.customInfo).length">
                      <div class="addBlock">
                        <div class="text-muted-0" style="margin-bottom:10px;margin-top:10px">
                          加購項目
                        </div>
                        <div v-for="(item, index) in addItems(event.customInfo)" :key="index">
                          <div style="margin-bottom:6px"
                            >{{ item.title }} <span class="text-muted-0"> - {{ item.serviceTime }} 分鐘</span>
                            <span v-if="item.paymentStatus === 'PAID'" class="addPaid"> 已付款</span>
                            <span v-if="item.paymentStatus === 'UNPAID'" class="addUnPaid"> 未付款</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div v-if="!hideOrderInfo(event)" class="remark">
                    <div class="remarkInner">
                      <el-popover :disabled="!showRemarkPopover" popper-class="popoverPadding" placement="right" width="300" trigger="click">
                        <RemarkDialog :column-show-list="columnShowList.filter((item) => item !== '會員等級')" :open-remark-info="openRemarkInfo" />
                        <el-button slot="reference" class="is-no-style" @click="openRemarkDialog(event.customInfo)">
                          <BaseIcon name="eye" />
                          <p>查看備註</p>
                        </el-button>
                      </el-popover>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="event.disabled" class="disabled"></div>
              <div v-else class="redirect" :class="{ disabled: changingBooking }">前往新增排班人員</div>
            </template>
          </VueCal>

          <!-- 一般訂單的contextmenu -->
          <v-contextmenu ref="contextmenu" :event-type="'click'" :class="[$style['contextmenu'], remarkContextMenuStatus ? $style['contextmenu--displayNone'] : '']" @contextmenu="onContext">
            <div v-if="selectedContextEvent.orderStatus" class="label-box">
              <!-- <BaseStateLabel v-if="selectedContextEvent.paymentMethod === 'Prepaid'" style="color: #2D385F">方案預約
              </BaseStateLabel> -->
              <span>
                一般訂單：
                <BaseStateLabel style="text-align: left;" :state="selectedContextEvent.paymentStatus | paymentStatusMapFilter('color')">{{
                  selectedContextEvent.paymentStatus | paymentStatusMapFilter('text')
                }}</BaseStateLabel>
              </span>
              <!-- 包月預約不為null才顯示 -->
              <template v-if="selectedContextEvent.prepaidOrderPaymentStatus !== null">
                <span
                  >包月訂單：<BaseStateLabel style="text-align: left;" :state="selectedContextEvent.prepaidOrderPaymentStatus | paymentStatusMapFilter('color')">{{
                    selectedContextEvent.prepaidOrderPaymentStatus | paymentStatusMapFilter('text')
                  }}</BaseStateLabel></span
                >
              </template>
              <BaseStateLabel state="info" :border-none="true">
                <span v-if="!selectedContextEvent.paymentMethod">付款方式：不指定</span>
                <span v-else class="outerPayStyle"><span class="payStyle">付款方式：</span>{{ selectedContextEvent.paymentMethod | orderPaymentMethodFilter }}</span>
              </BaseStateLabel>
            </div>
            <div class="contextMenuPaddingStyle">
              <v-contextmenu-item>
                <el-button style="text-align: center;width:150px;" type="primary" class="is-round" @click="onClickDetail">
                  查看訂單
                </el-button>
              </v-contextmenu-item>
              <v-contextmenu-item v-if="enableReschedule && selectedContextEvent.isBeautician === 1">
                <el-button style="text-align: center;width:150px;" class="is-round" @click="onClickChangingBooking">
                  變更預約時間
                </el-button>
              </v-contextmenu-item>
            </div>
          </v-contextmenu>

          <div id="custom-scrollbar" :class="$style['custom-scrollbar']">
            <div :style="`height:inherit;width: ${mirrorWidth}px;`"></div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </el-card>
    <div v-if="changingBooking" :class="[$style.footer, $style.booking]">
      <div class="content">
        <div class="title">變更預約模式</div>
        <div class="item">
          <div>{{ bookingTitle }}</div>
          <div class="date">改期至：{{ submitBooking.id ? submitBooking.startDate : '（請點擊空白時段）' }}</div>
        </div>
      </div>
      <div>
        <el-button class="is-round" @click="onCancelChanging">取消變更</el-button>
        <el-button class="is-round" type="primary" @click="onClickModify">確定變更</el-button>
      </div>
    </div>
    <!-- 編輯訂單 -->
    <el-drawer
      ref="orderFormEdit"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="drawerVisible"
      append-to-body
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :wrapper-closable="false"
      custom-class="order-drawer"
      :show-close="closeBtnShowStatus"
    >
      <ReservationOrderDetail
        v-if="!isModified"
        ref="orderDetail"
        order-type="reservation"
        :store-invoice-setting="storeInvoiceSetting"
        :fetch-types="fetchTypes"
        :default-value.sync="drawerOrderData"
        @update="tryToFetchSchedule"
        @onlyFetchSingleOrder="onlyFetchSingleOrder"
        @store="onEditOrderDone"
        @closeBtnShowFunc="closeBtnShowFunc"
        @closeAndReload="closeAndReload"
      />
      <ReservationOrderForm v-else :order-type="'reservation'" light-member-fetch :scheduleDetail="modifyOrder.scheduleItem" @store="onEditOrderDone" />
    </el-drawer>
    <!-- 新增訂單 -->
    <el-drawer
      ref="orderForm"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="createOrderVisible"
      :append-to-body="true"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :modal-append-to-body="false"
      :wrapper-closable="false"
      custom-class="order-drawer"
      :show-close="closeBtnShowStatus"
    >
      <ReservationOrderForm
        order-type="reservation"
        light-member-fetch
        :is-auto-open="false"
        :merchant-products="merchantProducts"
        :goods-order-id="currentOrderId"
        :is-use-staff-price-adj="isUseStaffPriceAdj"
        :fetch-types="fetchTypes"
        :service-time-setting="serviceTimeSetting"
        :off-line-params="offLineParams"
        :store-invoice-setting="storeInvoiceSetting"
        :products="createOrderData"
        :schedule-detail="createOrderExtraData"
        :schedules="schedules"
        :before-api-extra-fields="beforeApiExtraFields"
        @store="onCreateOrderDone"
        @closeBtnShowFunc="closeBtnShowFunc"
        @updateList="tryToFetchSchedule"
        @clearOffLineParams="removeOffLineParams"
        @closeAndReload="closeAndReload"
        @emitToLink="emitToLink"
        @changeCloseBtnShowStatus="changeCloseBtnShowStatus"
      />
    </el-drawer>
    <!-- 購買商品 -->
    <el-drawer
      ref="purchaseDrawer"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="purchaseDrawerOpen"
      :append-to-body="true"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :modal-append-to-body="false"
      :wrapper-closable="false"
      custom-class="order-drawer"
      :show-close="closeBtnShowStatus"
    >
      <PurchaseProducts :select-product-id="selectProductId" @closeBtnShowFunc="closeBtnShowFunc" @store="CreateGoodsOrderDone" @updateList="tryToFetchSchedule"></PurchaseProducts>
    </el-drawer>
    <OffLineReserveWindow
      ref="offLineReserveWindow"
      type="offTime"
      :over-time-reserve-window-status="overTimeReserveWindowStatus"
      @closeOffLineWindow="offTimeReserveResolveFunc"
      @previousFun="previousFun"
    />
    <StaffPriceAdjustment
      ref="staffPriceAdjustment"
      :create-order-extra-data="createOrderExtraData"
      :dialog-open-status="staffPriceAdjustmentWindowStatus"
      @adjust="adjustStatus"
      @closeSelfStaffPriceAdjustment="closeSelfStaffPriceAdjustment"
    />
  </div>
</template>
<style lang="scss">
@import '@src/design/vuecal-override.scss';

.schedule-wrap {
  margin-left: 20px;
  flex: 1 0 auto;
  width: 200px;
  height: calc(100vh - 350px);
  position: relative;

  @media screen and (max-height: 850px) {
    height: 540px !important;
  }

  @media screen and (min-height: 851px) and (max-height: 900px) {
    height: 555px !important;
  }

  @include max-sm {
    width: auto;
    height: auto;
  }

  .vuecal__time-column {
    @include max-sm {
      height: auto !important;
    }
  }
}

.schedule-calendar-collapse {
  :global {
    .closeCalendar {
      width: 100%;
      margin-bottom: 10px;
      border-radius: $border-radius;
    }

    .openCalendar {
      height: 100%;
      border-radius: $border-radius;
    }

    .openStatus {
      display: none;
    }
  }
}

.vue-cal-layout {
  display: flex;
  height: auto;
}
</style>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
$min-split-width: 200px;

@for $i from 1 through 30 {
  .split-labels-#{$i} {
    overflow-x: hidden;

    :global {
      .vuecal__header {
        // width: $min-split-width * $i + 42px;
        .vuecal__split-days-headers {
          height: auto !important;
          border-top: 0 !important;
          border-bottom: 0 !important;
          margin-left: 3.1em;
          box-shadow: inset 0px 0px 0px 0.5px rgba(0, 0, 0, 0.08);
          width: auto;
        }
      }
    }
  }
}

:global {
  .vuecal__flex {
    &.isWidth600 {
      .day-split-header {
        width: 600px !important;

        > div > span {
          width: auto;
        }
      }

      .vuecal__cell-content {
        min-width: 600px;
        max-width: 600px;
      }
    }

    &.isWidth300 {
      .day-split-header {
        width: 300px !important;

        > div > span {
          width: auto;
        }
      }

      .vuecal__cell-content {
        min-width: 300px;
        max-width: 300px;
      }
    }

    &.isWidthPhone {
      .day-split-header {
        width: calc(100vw - 185px) !important;
      }

      .vuecal__cell-content {
        min-width: calc(100vw - 185px);
        max-width: calc(100vw - 185px);
      }
    }

    &.isWidth200 {
      .day-split-header {
        width: 200px !important;

        > div > span {
          width: auto;
        }
      }

      .vuecal__cell-content {
        min-width: 200px;
        max-width: 200px;
      }
    }
  }

  .el-select-dropdown {
    &.isStylecColumnShowList {
      .el-select-dropdown__item.selected {
        &::after {
          display: none;
        }
      }

      .el-select-dropdown__item.hover {
        background-color: white;
        color: $color-primary;
      }
    }
  }

  .popoverPadding {
    padding: 28px 37.5px;
  }
}

.schedule {
  // border-radius: 4px;
  box-shadow: inherit !important;
  position: relative;

  // 若變更服務時間較長的訂單時間，時間無法從10:00改到10:30 (點擊不到這個時間點)
  &.is-changing {
    :global {
      .vuecal__cell-content:not([data-split='create-staff']) {
        .vuecal__event:not(.vuecal__event--background) {
          pointer-events: none;
        }
      }
    }
  }

  :global {
    .vuecal__header {
      width: auto;
      overflow-x: scroll;
      min-height: 42px;
      margin-left: 42px;

      // 行事曆上方header位置
      .vuecal__split-days-headers {
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        margin-left: 2px !important;
        display: inline-flex;

        .day-split-header {
          width: 300px;
          height: 44px;

          > .el-button span {
            white-space: nowrap;
            text-overflow: ellipsis;
            width: auto;
            display: block;
            overflow: hidden;
          }

          .el-dropdown {
            width: 99%;

            button {
              border: none;
              width: 100%;

              span {
                display: flex;
                justify-content: space-between;
              }
            }
          }

          & + .day-split-header {
            border-left: 1px solid rgb(198 198 186 / 0.7);
          }
        }
      }
    }

    .vuecal__time-cell-line::before {
      left: 43px;
      width: 3000px;
    }

    .vuecal__body {
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 42px;
        width: 100%;
        height: 1px;
        background: rgba(0, 0, 0, 0.08);
      }

      .vuecal__bg > .vuecal__flex {
        overflow-x: scroll;
        overflow-y: scroll;
        display: block;

        // 這裡可以調整時間序列欄位
        .vuecal__time-column {
          position: absolute;
          height: 4797px;
          left: 0;
          background: #fff;
          z-index: 4;
          padding-top: 40px;
          margin-top: -40px;

          .vuecal__time-cell {
            background: white;
            padding-right: 4px;
            text-align: left;

            &:last-child {
              box-shadow: 0px 1px white;
            }
          }
        }

        .vuecal__cells {
          height: 4797px;
          padding-left: 3.1rem;

          .vuecal__cell {
            width: auto;
            justify-content: inherit;
          }
        }
      }
    }

    .vuecal__cell-content {
      // max-width: 300px;
      min-width: 300px;
      padding-left: 30px;

      .vuecal__no-event {
        display: none;
      }

      .vuecal__event {
        background-color: transparent;

        .wrap {
          padding: 10px;
          border-radius: 8px;
          border-width: 2px;
          border-style: solid;
          text-align: left;

          .name {
            font-size: 16px;
            letter-spacing: 1.4px;
            line-height: 20px;
            color: #3f3a2e;
            margin-bottom: 5px;
            font-weight: 400;
          }

          .title {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;

            .time {
              font-size: 15px;

              .cycle {
                font-weight: 400;
              }
            }

            svg {
              color: white;
              background: green;
              padding: 6px;
              font-size: 30px;
              border-radius: 6px;
              padding-left: 8px;
            }
          }

          // 已完成
          &.finish {
            border-color: $color-sched-state-finish;
            background-color: #f0fcff;

            .addBlock,
            .remark {
              border-color: $color-sched-state-finish;
            }
          }

          // 已報到
          &.success {
            border-color: $color-sched-state-success;
            background-color: #f2fffb;

            .addBlock,
            .remark {
              border-color: $color-sched-state-success;
            }
          }

          // 待報到
          &.warning {
            border-color: $color-sched-state-warning;
            background-color: #fff9f4;

            .addBlock,
            .remark {
              border-color: $color-sched-state-warning;
            }
          }

          // 未報到
          &.danger {
            border-color: $color-sched-state-danger;
            background-color: #fff4f4;

            .addBlock,
            .remark {
              border-color: $color-sched-state-danger;
            }
          }

          // 未付款
          &.info {
            border-color: $color-sched-state-info;
            background-color: lighten($color-sched-state-info, 10%);

            .addBlock,
            .remark {
              border-color: $color-sched-state-info;
            }
          }

          &.is-disabled {
            pointer-events: none;

            &::before {
              content: '';
              position: absolute;
              top: -10px;
              bottom: -10px;
              left: -10px;
              right: -10px;
              background: white;
              opacity: 0.65;
            }
          }

          &.is-changing {
            pointer-events: none;
          }

          &.isHelper {
            border-style: dashed;
          }

          &.isUNPAIDADD {
            border-color: #e2b550;
            background-color: #fbf6e9;

            .addBlock {
              border-color: #e2b550;
            }

            .remark {
              border-color: #e2b550;
            }
          }

          // 未付款
          &.isUNPAID {
            border-color: $color-sched-state-info;
            background-color: #f5f5f5;

            .addBlock {
              border-color: $color-sched-state-info;
            }

            .remark {
              border-color: $color-sched-state-info;
            }
          }
        }

        .redirect {
          height: inherit;
          display: flex;
          flex-direction: column;
          padding-top: 80px;
          // justify-content: center;
          background: #fcfcfc;
          cursor: pointer;

          &.disabled {
            pointer-events: none;
            color: rgb(102 102 102 / 0.5);
          }
        }

        &.vuecal__event--background {
          margin-top: 2px;

          // z-index: 3;
          .disabled {
            height: inherit;
            background: repeating-linear-gradient(45deg, lightgrey 0px, lightgrey 2px, #f2f2f2 0px, #f2f2f2 7px);
            opacity: 0.5;
            box-shadow: inset 0 -2px white;
            pointer-events: none;
          }
        }

        &:not(.vuecal__event--background) {
          // z-index: 4 !important;
        }
      }

      & + .vuecal__cell-content {
        border-left: 1px solid rgba(0, 0, 0, 0.08);
      }
    }
  }
}

.min10Height {
  :global {
    .vuecal__body {
      .vuecal__bg > .vuecal__flex {
        // 這裡可以調整時間序列欄位
        .vuecal__time-column {
          height: 7195px !important;
        }

        .vuecal__cells {
          height: 7195px !important;
        }
      }
    }
  }
}

.min30Height {
  :global {
    .vuecal__body {
      .vuecal__bg > .vuecal__flex {
        // 這裡可以調整時間序列欄位
        .vuecal__time-column {
          height: 2400px !important;
        }

        .vuecal__cells {
          height: 2400px !important;
        }
      }
    }
  }
}

.min60Height {
  :global {
    .vuecal__body {
      .vuecal__bg > .vuecal__flex {
        // 這裡可以調整時間序列欄位
        .vuecal__time-column {
          height: 1200px !important;
        }

        .vuecal__cells {
          height: 1200px !important;
        }
      }
    }
  }
}

:global() {
  :local(.schedule) {
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 42px;
      width: calc(100% - 9px);
      height: 1px;
      background: rgb(0 0 0 / 0.08);
    }
  }
}

.card-wrapper {
  // min-height: 79vh;
  background-color: white;

  @include max-sm {
    overflow-x: scroll;
  }

  :global {
    .el-card__body {
      position: relative;
    }
  }
}

.filter {
  :global {
    input {
      height: 40px;
      background: white;
      border: 2px solid lightgray;
      border-radius: 9px;
    }

    i,
    input::placeholder {
      color: #333 !important;
    }
  }
}

.booking {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;

  z-index: 15;

  :global {
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        background-color: #c79484;
        color: white;
        font-size: 16px;
        border-radius: 25px;
        padding: 10px 20px;
        letter-spacing: 3px;
        text-align: center;
        padding-right: 13px;
      }

      .item {
        font-size: 14px;
        margin-left: 30px;
        text-align: left;

        .date {
          color: rgb(227 93 93);
          margin-top: 10px;
        }
      }
    }

    .el-button {
      width: 150px;
      height: 45px;
      letter-spacing: 4px;

      &:last-child {
        @include max-sm {
          margin-left: 0 !important;
        }

        @include max-md {
          margin-left: 0 !important;
        }

        @include max-lg {
          margin-left: 0 !important;
        }
      }
    }
  }
}

.status {
  font-size: 14px;
  line-height: 20p;
  color: #3f3a2e;
  font-weight: 500;
  letter-spacing: 1.4px;
}

.calendar-status-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 250px;
}

.calendar-status {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 10px;
  width: 50%;

  :global {
    .mark {
      background-color: $color-primary;
      border-radius: 20px;
      padding: 6px 10px;
      margin-right: 10px;

      &-1 {
        color: white;
      }

      &-2 {
        background-color: transparent;
      }

      &-3 {
        background-color: transparent;
        opacity: 0.25;
      }

      &-available {
        background-color: rgba(#f9d2bf, 0.4);
        color: $color-text-secondary;
      }

      &-full {
        background-color: #f2eae6;
        color: #c79484;
      }
    }
  }
}

.order-status {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 20px;
  width: 33.33333%;

  :global {
    .mark {
      padding: 7px;
      margin-right: 15px;

      // 已完成
      &-1 {
        background-color: $color-sched-state-finish;
      }

      // 已報到
      &-2 {
        background-color: $color-sched-state-success;
      }

      // 待報到
      &-3 {
        background-color: $color-sched-state-warning;
      }

      // 未報到
      &-4 {
        background-color: $color-sched-state-danger;
      }

      // 未付款
      &-5 {
        background-color: $color-sched-state-info;
      }

      &-6 {
        background-color: #f56c6c;
      }
    }
  }
}

.contextmenu {
  width: 210px;

  :global {
    .contextMenuPaddingStyle {
      padding: 20px 0;
    }

    .outerPayStyle {
      color: $color-heading-text;
    }

    .payStyle {
      color: $color-text-light;
    }

    .v-contextmenu-item {
      font-size: 15px;
      text-align: center;
      min-width: 150px;

      &.v-contextmenu-item--hover {
        background-color: transparent;
      }
    }
  }

  &--displayNone {
    display: none;
  }

  &--displayShow {
    display: block;
  }
}

.contextmenu2 {
  width: 300px;

  :global {
    .contextMenuPaddingStyle {
      padding: 20px 0;
    }

    .outerPayStyle {
      color: $color-heading-text;
    }

    .payStyle {
      color: $color-text-light;
    }

    .v-contextmenu-item {
      padding: 28px 40px;
      font-size: 15px;
      text-align: center;
      min-width: 150px;

      &.v-contextmenu-item--hover {
        background-color: white;
        color: $color-secondary;
      }
    }
  }

  &--displayNone {
    display: none;
  }

  &--displayShow {
    display: block;
  }
}

.split-label {
  text-align: left;
  width: 100%;
  font-weight: 500;
  // padding: 13px 18px;
  background: #e8e8e3;
  border-color: #c6c6ba;
  height: 42.1px;
  display: flex;
  align-items: center;
  justify-content: center;

  :global {
    span {
      width: 200px;
      height: 25px;
      overflow-x: scroll;
      margin-left: 5px;
      line-height: 25px;

      &.isWidth600 {
        width: 300px;
        overflow-x: scroll;
      }

      &.isWidth300 {
        width: 130px;
        overflow-x: scroll;
      }

      &.isWidthPhone {
        width: 75px;
        overflow-x: scroll;
      }
    }
  }
}

.title:not(:first-child) {
  margin-top: 30px;
}

.mask {
  pointer-events: none;
}

.custom-scrollbar {
  position: absolute;
  bottom: 0;
  height: 16px;
  left: 0;
  right: 0;
  margin-left: 42px;
  margin-right: -15px;
  bottom: -15px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: block;
    height: 16px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: #dcdad8;
    box-shadow: inset 0px 0px 0px 4px rgb(245 245 245 / 1);
  }

  &::-webkit-scrollbar-track {
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }
}

.mainBlock {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  height: 100%;

  :global {
    .name {
      margin-bottom: 15px !important;
    }

    .contextPart {
      overflow: auto;
      overscroll-behavior: contain;

      &:hover {
        cursor: pointer;
      }
    }

    .time {
      display: inline-block;
    }

    .title {
      margin-top: 0 !important;
      display: block !important;
      margin-bottom: 15px;
    }

    .info-icon {
      color: #fff;
      background-color: $color-primary;
      display: inline-block;
      position: absolute;
      right: 0px;
      top: 0px;
      padding: 7px 10px;
      font-weight: 300;
      font-size: 14px;

      &.isPrepaid {
        background-color: #2d385f;
      }
    }

    .specify-schedule-item {
      position: absolute;
      left: 0px;
      top: 0px;
      font-weight: 300;
      font-size: 12px;
      color: #fa0501;
      padding: 5px 10px;
      background-color: #fee9e4;
      border-radius: 20px;
    }

    .addBlock {
      border-top: $color-text-light 1px solid;
      margin-top: 14px;
      padding: 4px 0 8px;
      flex-grow: 1;
    }

    .addPaid {
      font-size: 12px;
      color: #12c494;
    }

    .levelTitle {
      border-radius: $border-radius;
      background-color: $color-line-dark;
      padding: 5px 10px;
      font-size: 14px;
      text-align: center;
      margin-right: 10px;
      white-space: nowrap;
      margin-bottom: 5px;
      display: inline-block;
      margin-top: 5px;
    }

    .tagsGroup {
      display: flex;
      margin-top: 10px;
      flex-direction: column;
      height: auto;
      flex-wrap: wrap;

      .tagsBody {
        display: flex;
        flex-wrap: wrap;

        .tagsTitle {
          border-radius: $border-radius;
          background-color: $color-line-dark;
          padding: 5px 10px;
          font-size: 14px;
          text-align: center;
          margin-right: 10px;
          white-space: nowrap;
          margin-bottom: 5px;
        }
      }
    }

    // .tagsTitle {
    //   display: flex;
    //   padding: 10px;
    //   justify-content: flex-start;
    //   align-items: center;
    //   margin-right: 10px;
    //   flex-wrap: wrap;

    //   p {
    //     height: 30px;
    //     border-radius: $border-radius;
    //     background-color: $color-line;
    //     color: #121931;
    //     text-align: center;
    //     font-size: 14px;
    //   }
    // }

    .addUnPaid {
      font-size: 12px;
      color: red;
    }

    .remark {
      border-top: $color-text-light 1px solid;
      display: flex;
      align-items: end;
      justify-content: center;

      .remarkInner {
        display: flex;
        justify-content: center;
        align-items: center;

        :global {
          .el-button {
            span {
              display: flex;
              justify-content: center;
              align-items: center;
              overflow-x: auto;

              svg {
                color: $color-primary;
                margin-right: 10px;
              }

              p {
                color: $color-secondary;
              }
            }
          }
        }
      }
    }
  }
}

.upperIndex {
  background-color: white;
}

.pageTitle {
  padding: 0 10px 20px;
  background-color: $color-body-bg;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include max-sm {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 20px 15px;
  }

  @include max-md {
    flex-direction: column;
    align-items: flex-start;
  }

  @include max-lg {
    flex-direction: column;
    align-items: flex-start;
  }

  :global {
    .upperInfo {
      display: flex;
      flex-direction: column;

      > p {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

    .verticalLine {
      height: 50px;
      width: 1px;
    }

    .upperItemDisplay {
      margin-right: 20px;
      display: flex;
      flex-direction: column;

      @include max-sm {
        flex-direction: column;
      }

      @include max-md {
        flex-direction: column;
        margin-right: 10px;
      }

      @include max-lg {
        flex-direction: column;
      }
    }

    .upperBtnDisplay {
      display: flex;
      align-items: center;

      @include max-sm {
        flex-direction: column;
        width: 100%;

        :global {
          .el-button {
            width: 100%;
            margin-left: 0;
            margin-top: 10px;
          }
        }
      }

      @include max-md {
        flex-direction: column;

        :global {
          .el-button {
            width: 100%;
            margin-left: 0;
            margin-top: 10px;
          }
        }
      }

      @include max-lg {
        flex-direction: column;

        :global {
          .el-button {
            width: 100%;
            margin-left: 0;
            margin-top: 10px;
          }
        }
      }
    }

    .leftItem {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
      margin-right: 10px;
      align-items: center;

      @include max-sm {
        width: 100%;
        flex-direction: column;
      }

      @include max-md {
        width: 100%;
        flex-direction: column;
      }

      @include max-lg {
        width: 100%;
        flex-direction: column;
      }
    }

    .innerItem {
      display: flex;

      &:first-child {
        margin-bottom: 10px;
      }

      .text-btn {
        &:hover {
          cursor: pointer;
        }
      }

      .isActive {
        color: $color-primary;
      }

      @include max-sm {
        margin-bottom: 10px;
        flex-direction: column;
      }

      @include max-md {
        margin-bottom: 10px;
      }

      @include max-lg {
        margin-bottom: 10px;
      }
    }

    .choiceDisplay {
      display: flex;

      @include max-sm {
        margin-top: 10px;
      }
    }

    .phoneSelectWidth {
      @media screen and (min-width: 482px) {
        display: none;
      }
    }
  }
}

.fieldStyle {
  position: relative;
  width: 173px;

  @include max-sm {
    margin-top: 10px;
    width: 100%;
  }

  @include max-md {
    margin-top: 10px;
    width: 100%;
  }

  @include max-lg {
    margin-top: 10px;
    width: 100%;
  }

  :global {
    .showText {
      color: $color-secondary;
      position: absolute;
      z-index: 2;
      width: 80%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 33px;

      svg {
        margin-right: 10px;
      }
    }

    .el-select {
      height: 44px;
    }

    .el-select__tags {
      display: none;
      height: 44px;
      // 如果要橫向排列，開啟下面的
      // overflow-x: auto;
      // span {
      //   display: flex;
      // }
    }
  }
}

.eventMask {
  position: absolute;
  z-index: 100000;
  background: rgba(52, 51, 51, 0.8);
  width: 100%;
  height: inherit;
  border-radius: $border-radius;
  display: flex;
  justify-content: center;
  align-items: center;
  // backdrop-filter: blur(2px);
  overflow-y: scroll;

  > p {
    color: white;
    z-index: 1;
  }
}
</style>
